import {
  Box,
  ListItemText,
  MenuItem,
  Select
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
  BanknoteX,
  ChevronDown,
  LoaderCircle,
  LucideSearch,
  //Play,
  SquareCheck,
  X
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { CancelIconWrapper, Search, SearchIconWrapper, SearchInputBase } from "../../components/Header/Header.styles";

interface ExternalSidebarProps {
  filter: string;
  onFilterChange?: (value: string) => void;
  selectedStatus: string[];
  setSelectedStatus: (value: string[]) => void;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

export function ExternalSidebar({
  //filter,
  //onFilterChange,
  selectedStatus,
  setSelectedStatus,
  searchTerm,
  setSearchTerm
}: ExternalSidebarProps) {
  const { t } = useTranslation();
  const theme = useTheme();

  const ChevronIcon = () => (
    <ChevronDown
      color={ theme.customColors.textPrimary }
      size={ 18 }
      style={ {
        pointerEvents: "none",
        position: "absolute",
        right: 10
      } }
    />
  );

  return (
    <Box
      sx={ {
        alignItems: { sm: "center", xs: "stretch" },
        display: "flex",
        flexDirection: { sm: "row", xs: "column" },
        gap: 2,
        width: "100%",
        height: "2.2rem"
      } }
    >
      { /* 1) Barra di ricerca */ }
      <Search
        sx={ {
          flex: 1,
          maxWidth: { sm: "280px", xs: "100%" },
          width: "100%",
          height: "2.2rem",
          [theme.breakpoints.down("sm")]: {
            display: "flex",
            padding: "8px 16px"
          }
        } }
      >
        <SearchIconWrapper>
          <LucideSearch
            aria-hidden="true"
            color={ theme.customColors.backgroundPrimaryCta }
            size={ 20 }
          />
        </SearchIconWrapper>
        <SearchInputBase
          inputProps={ { "aria-label": "search" } }
          onChange={ e => setSearchTerm(e.target.value) }
          placeholder={ `${t("search_training")}?` }
          value={ searchTerm }
        />
        <CancelIconWrapper
          aria-hidden={ !searchTerm ? "true" : undefined }
          aria-label={ t("empty_field") }
          onClick={ () => setSearchTerm("") }
          sx={ {
            cursor:"pointer"
          } }
        >
          { searchTerm ? (
            <X 
              aria-hidden="true"
              color={ theme.customColors.textPrimaryAlternative }
              fontSize="1rem" 
            />

          ) : null }
        </CancelIconWrapper>
      </Search>

      { /* 2) Select Stato */ }
      <Select
        displayEmpty
        multiple
        onChange={ (e) =>
          setSelectedStatus(e.target.value as string[])
        }
        onClose={ () => { /* noop */ } }
        onOpen={ () => { /* noop */ } }
        renderValue={ () => t("status") }
        value={ selectedStatus }
        IconComponent={ ChevronIcon }
        sx={ {
          ".MuiSelect-select": {
            paddingBottom: "8px",
            paddingTop: "8px",
            fontSize: "0.875rem"
          },
          ".MuiInputBase-input": {
            fontSize: "0.875rem"
          },
          backgroundColor:
            theme.customColors.backgroundPrimary,
          border: `1px solid ${theme.customColors.border}`,
          borderRadius: "8px",
          boxShadow: "none",
          color: theme.customColors.textPrimary,
          fontWeight: 500,
          height: "2.2rem",
          textTransform: "capitalize",
          width: { sm: "140px", xs: "100%" }
        } }
        MenuProps={ {
          PaperProps: {
            sx: {
              backgroundColor:
                `${theme.customColors.backgroundPrimary
                } !important`,
              borderRadius: "8px",
              boxShadow: theme.shadows[3],
              color:
                `${theme.customColors.textPrimary
                } !important`,
              fontSize: "0.875rem",
              mt: 1
            }
          }
        } }
      > 
        { /*
        <MenuItem sx={ { gap: 1.5, px: 2 } } value="TO_START">
          <Play size={ 16 } />
          <ListItemText
            primary={ t("to_start") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
         */ }
        <MenuItem sx={ { gap: 1.5, px: 2 } } value="PENDING">
          <LoaderCircle size={ 16 } />
          <ListItemText
            primary={ t("pending") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
        { /*TODO: DA ELIMINARE QUANDO SONO PRONTE LE API */ }
        <MenuItem sx={ { gap: 1.5, px: 2 } } value="REJECTED">
          <BanknoteX size={ 16 } />
          <ListItemText
            primary={ t("rejected") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
        { /* <MenuItem
          sx={ { gap: 1.5, px: 2 } }
          value="IN_PROGRESS"
        >
          <LoaderCircle size={ 16 } />
          <ListItemText
            primary={ t("in_progress") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>*/ }
        
        <MenuItem sx={ { gap: 1.5, px: 2 } } value="APPROVED">
          <SquareCheck size={ 16 } />
          <ListItemText
            primary={ t("approved") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
        { /* 
        <MenuItem
          sx={ { gap: 1.5, px: 2 } }
          value="COMPLETED"
        >
          <SquareCheck size={ 16 } />
          <ListItemText
            primary={ t("completed") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>*/ }
      </Select>

      { /* 3) Select Tipo 
      <Select
        displayEmpty
        onChange={ (e) => {
          if (onFilterChange) {
            onFilterChange(e.target.value as string);
          }
        } }
        renderValue={ () =>
          filter === "all"
            ? (t("type_training") || "Tipo")
            : filter
        }
        value={ filter }
        IconComponent={ ChevronIcon }
        sx={ {
          ".MuiSelect-select": {
            paddingBottom: "8px",
            paddingTop: "8px"
          },
          backgroundColor:
            theme.customColors.backgroundPrimary,
          border: `1px solid ${theme.customColors.border}`,
          borderRadius: "8px",
          boxShadow: "none",
          color: theme.customColors.textPrimary,
          fontWeight: 500,
          minHeight: "40px",
          textTransform: "capitalize",
          width: { sm: "140px", xs: "100%" }
        } }
        MenuProps={ {
          PaperProps: {
            sx: {
              backgroundColor:
                `${theme.customColors.backgroundPrimary
                } !important`,
              borderRadius: "8px",
              boxShadow: theme.shadows[3],
              color:
                `${theme.customColors.textPrimary
                } !important`,
              mt: 1
            }
          }
        } }
      >
     
        <MenuItem sx={ { px: 2 } } value="all">
          <ListItemText
            primary={ t("all") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
     --Interna --
        <MenuItem sx={ { px: 2 } } value="interna">
          <ListItemText
            primary="Interna"
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
        --- Esterna (label, non selezionabile) --
        <MenuItem
          disabled
          sx={ { opacity: "1 !important", px: 2 } }
        >
          <ListItemText
            primary="Esterna"
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 600
            } }
          />
        </MenuItem>
     --Iscrizione (indentato)--
        <MenuItem sx={ { pl: 5, pr: 2 } } value="iscrizione">
          <ListItemText
            primary={ t("subscriptions") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 400
            } }
          />
        </MenuItem>
       --Consultivazione (indentato)---
        <MenuItem
          sx={ { pl: 5, pr: 2 } }
          value="consultivazione"
        >
          <ListItemText
            primary={ t("consuntivations") }
            primaryTypographyProps={ {
              fontSize: "14px",
              fontWeight: 400
            } }
          />
        </MenuItem>
      </Select>
      */ }
    </Box>
  );
}

export default ExternalSidebar;
